import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { SectionBListLayer } from '../components/ImportQuestion/SectionBListLayer'

export const SectionBListPage = () => {
  return (
    <MasterLayout>
        <SectionBListLayer/>
    </MasterLayout>
  )
}
